export const JUSTIFY_ITEMS_CLASSES = {
    start: 'justify-items-start',
    end: 'justify-items-end',
    center: 'justify-items-center',
    stretch: 'justify-items-stretch',
};
export const applyJustifyItems = (justifyItems) => [
    ...(justifyItems ? [JUSTIFY_ITEMS_CLASSES[justifyItems]] : []),
];
